<template>
  <div :class="{
    'memory-gallery-container': true,
    'memory-gallery-bg-light': memoryEnterFlag,
    }"
  >
    <div :class="{
      'memory-gallery-title-wrapper': true,
      'memory-gallery-title-fade-in': memoryEnterFlag,      
      }"
    >
      <img width="100%" :src="require('../assets/images/memory/921_page_title_black.png')"  alt="天亮之後">
    </div>
    <!-- <TitleSvg :memoryEnterFlag="memoryEnterFlag"></TitleSvg> -->
    <div :class="{
      'memory-gallery-sub-title': true,
      'memory-gallery-sub-title-fade-in': memoryEnterFlag,
      }"
    >
      <p>20 years after the September 21st Earthquake.</p>
      <p>At the end, we’d like you to write a letter to September 21st.</p>
    </div>
    <div :class="{
      'memory-button': true,
      'memory-button-fade-in': memoryEnterFlag,
      }"
      @click="sendMemoryGA()"
    >
      <a href="https://udn.com/newmedia/921/memory/#/2" name="我想寫信" target="_blank">Write a letter</a>
    </div>
    <div :class="{
      'memory-gallery-wrapper': true,
      'memory-gallery-fly-in': memoryEnterFlag,
      }"
    >
      <Slick
        ref="slick"
        :options="{
          dots: false,
          infinite: true,
          speed: 200,
          slidesToShow: computeSlidesToShow,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: computeSlickPadding,
          arrows: false,
          initialSlide: 0,
        }"
      >
        <div class="memory-card-wrapper">
          <a href="https://udn.com/newmedia/921/memory/#/" name="寫一封信給921" target="_blank">
            <div class="memory-card">
              <div class="profile-wrapper">
                <div class="profile-picture">
                  <img :src="require('../assets/images/memory/papercrane.svg')" height="50" width="50"/>
                </div>
                <div class="profile-name-wrapper">
                  <div class="profile-job">
                    　　
                  </div>
                  <div class="profile-name">
                    阿盛
                  </div>
                </div>
              </div>
              <div class="text-container">
                <div class="text-wrapper">
                  {{
                    '921我們那邊好像死了300多人，一整排白布，都蓋著，有兩包、有一包，有的一個大一個小，看了你就覺得，怎麼會這樣，怎麼死了這麼多人。\n地震發生時，只知道要把頭抱著，因為東西一直掉下來，我們兩兄弟比較好，沒有被壓到，但爸爸媽媽都走了，碰一聲，什麼都不見了。\n那一村只有我們家裡死兩個，我們的已經蓋著了，離我們200多公尺，有一個人還埋在裡面，我就跟救難隊說，先去救他們吧，我們的已經沒有救了，都壓著怎麼救？他們的喊了還有聲音，我們的都沒有聲了。\n剛開始那一、兩個月，都會聞到味道，屍體臭掉的味道。但我看不到，想說：啊，他有來。我也曾夢過他們，但他們不會跟我講話，他們出現就代表他們在鼓勵你，不是要讓你難過。\n921後，就覺得，你能活多久不知道，昨天還在講話、還在吃飯，碰，隔天就不見了，活在當下快樂就好，不要斤斤計較了。'
                  }}
                </div>
                <div class="text-mask"></div>
              </div>
              <div class="full-button">
                繼續閱讀
              </div>
            </div>
          </a>
        </div>
        <div class="memory-card-wrapper">
          <a href="https://udn.com/newmedia/921/memory/#/" name="寫一封信給921" target="_blank">
            <div class="memory-card">
              <div class="profile-wrapper">
                <div class="profile-picture">
                  <img :src="require('../assets/images/memory/papercrane.svg')" height="50" width="50"/>
                </div>
                <div class="profile-name-wrapper">
                  <div class="profile-job">
                    　　
                  </div>
                  <div class="profile-name">
                    陳靜怡
                  </div>
                </div>
              </div>
              <div class="text-container">
                <div class="text-wrapper">
                  {{
                    '我那時是在睡夢中，凌晨一點多突然一陣搖晃，眼睛睜開時還是亮亮的有燈，突然之間整個就沒電了，天昏地暗，然後一陣很劇烈的搖晃。\n那個時候我在台中，凌晨四五點時聽到廣播，說震央在埔里這邊，而且災情蠻嚴重，橋都斷了，我一直打電話給爸爸媽媽，完全都打不通，我一顆心真的放不下，天一亮就回來埔里了。\n在回來那段路，心情真的很難熬，平常一個小時的車程我開了五、六個小時，這期間完全聯絡不到爸爸媽媽，後來一看到我家還完整健在的時候，我就相信家人一定都在，見到他們的那一刻，我好像從懸崖下面爬上來一樣，覺得自己很幸運，也很感謝老天爺讓他們都還在。\n921讓我懂得怎麼珍惜家人、怎麼和家人相處，而且讓我說出以前不敢說的話。以前或許我們敬愛父母，但我們不會說，當我回來看到爸爸媽媽的那一刻，我覺得擁抱也是921給我的勇氣和表現，沒有什麼是不能說、不能做的。'
                  }}
                </div>
                <div class="text-mask"></div>
              </div>
              <div class="full-button">
                繼續閱讀
              </div>
            </div>
          </a>
        </div>
        <div class="memory-card-wrapper">
          <a href="https://udn.com/newmedia/921/memory/#/" name="寫一封信給921" target="_blank">
            <div class="memory-card">
              <div class="profile-wrapper">
                <div class="profile-picture">
                  <img :src="require('../assets/images/memory/papercrane.svg')" height="50" width="50"/>
                </div>
                <div class="profile-name-wrapper">
                  <div class="profile-job">
                    消防局小隊長
                  </div>
                  <div class="profile-name">
                    柯文進
                  </div>
                </div>
              </div>
              <div class="text-container">
                <div class="text-wrapper">
                  {{
                    '921那天剛洗完澡躺下來，沒多久就發生地震，當下背包都還沒整理，包包背著就跟老婆小孩說，爸爸要去上班了，就回到二里消防消防分隊去待命。\n趕到現場，真的是煉獄，四、五棟大樓全倒、往下塌陷，還有人受傷在哀嚎，地下室在冒煙，一片斷壁殘垣，現場民眾都跑出來，都是很慌亂的表情。\n救援過程中，發現有棟樓底下有車子被壓住，正冒著煙，我和另外兩人怕車子會起火，就拉著水帶鑽到地下去找那幾部車。第一次餘震的時候，因為我在前面，後面的人就抓著我的腳，第三個抓著第。\n搖晃完之後再繼續爬，再往前鑽又發生餘震，我想說奇怪，為什麼這次餘震，我後面的腳沒有人抓了，側身去看，才發現我後面的人已經不見了，找到冒煙車輛時只剩我一個，慢慢的，車開始起火，我就滅火，可是餘震還是一直發生，那空間只剩下你一個，又很黑暗，就很像這個世界只剩下你一個人在這邊。\n那時救災完之後，有一段時間，心裡真的有一段陰影，當時有一段時間真的靠酒精的麻痺，不然我沒辦法睡覺。'
                  }}
                </div>
                <div class="text-mask"></div>
              </div>
              <div class="full-button">
                繼續閱讀
              </div>
            </div>
          </a>
        </div>
        <div class="memory-card-wrapper">
          <a href="https://udn.com/newmedia/921/memory/#/" name="寫一封信給921" target="_blank">
            <div class="memory-card">
              <div class="profile-wrapper">
                <div class="profile-picture">
                  <img :src="require('../assets/images/memory/papercrane.svg')" height="50" width="50"/>
                </div>
                <div class="profile-name-wrapper">
                  <div class="profile-job">
                    　　
                  </div>
                  <div class="profile-name">
                    阿健
                  </div>
                </div>
              </div>
              <div class="text-container">
                <div class="text-wrapper">
                  {{
                    '我們家是四層樓的建築，我和弟弟妹妹睡在三樓。發生地震時，我起來去叫爸爸媽媽起床，我媽媽有回應我，後來又連續強震，到樓梯口時，樓梯已經變形了，沒辦法往下走，我就帶我弟我妹靠著門框，至少穩固一點，後來最強震出現，看到沙發在空中翻滾，整個玻璃外牆都往路面倒，等到再過20、30分鐘，呼叫都沒有聲音了，聽到腳步聲往外看，才發現三樓已經變成一樓的高度，一、二樓都坍塌了。\n爸爸媽媽應該是在最強震那時候就離開了。剛把他們找出來時真的是崩潰大哭，一半也是嚇到，覺得不是這樣吧，假的吧，不太能夠接受事情真的發生。\n發生後的一兩個禮拜內，我就必須接受這個事情是真的，在這過程中，我給自己的調適是，父母親早晚會離開，只是他們來得很突然，讓我們必須提早面對這件事。\n我把父母離開這件事看得比較理性，生活中其實不太會特別想到他們不在這件事，有人問我，你爸媽呢？我都會說他們出國了，去天國。\n對我來講，我會覺得他們好像是搬到其他地方生活了，不太方便連絡，這樣子想會覺得比較舒服簡單一點，也不會覺得他們是不見了，或是不在了這樣。'
                  }}
                </div>
                <div class="text-mask"></div>
              </div>
              <div class="full-button">
                繼續閱讀
              </div>
            </div>
          </a>
        </div>
        <div class="memory-card-wrapper">
          <a href="https://udn.com/newmedia/921/memory/#/" name="寫一封信給921" target="_blank">
            <div class="memory-card">
              <div class="profile-wrapper">
                <div class="profile-picture">
                  <img :src="require('../assets/images/memory/papercrane.svg')" height="50" width="50"/>
                </div>
                <div class="profile-name-wrapper">
                  <div class="profile-job">
                    南投縣生活重建協會理事長
                  </div>
                  <div class="profile-name">
                    邱慶禧
                  </div>
                </div>
              </div>
              <div class="text-container">
                <div class="text-wrapper">
                  {{
                    '921那晚我是被搖醒的，然後電視機砸下來，嚇醒第一時間就趕快抱小孩，正打算從屋裡逃出來，結果樓梯瞬間不見了，只能從二樓爬下來。\n那一天我們搶救了一、二十個，包含受傷、往生的，第二天剛好有一個餘震蠻大的，我生平不曾看過九九峰會跳舞，整個山頭都是霧茫茫的、都是白煙，山頭上完全沒有樹了，都被搖下來，光禿禿的一片。\n我們這邊那天大概往生15個左右，福龜全倒的大概319間，半倒的318間，我們住家也是全倒，我就把土地捐給協會，建構一個社工的辦公室、日照中心，大概建地5、600坪，全數捐給協會來做使用。\n你說921讓我看到什麼? 讓我體會到什麼? 我坦白講，從人最貧困的時候，你伸出援手幫忙他，讓他有一頓溫飽，讓他走出悲情、重生，讓他恢復到日常生活，那是我們內心最大的欣慰。'
                  }}
                </div>
                <div class="text-mask"></div>
              </div>
              <div class="full-button">
                繼續閱讀
              </div>
            </div>
          </a>
        </div>
      </Slick>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';

import TitleSvg from './TitleSvg.vue';
import Slick from 'vue-slick';
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';

export default {
  name: 'MemoryGallery',
  components: {
    TitleSvg,
    Slick,
  },
  props: {
    memoryEnterFlag: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computeSlickPadding() {
      if (window.innerWidth > 1280) {
        return '15vw';
      } else if (window.innerWidth > 1024 && window.innerWidth <= 1280){
        return '5vw';
      } else {
        return '8vw'
      }
    },
    computeSlidesToShow() {
      if (window.innerWidth < 1024) {
        return 1;
      } else {
        return 3;
      }
    },
  },
  methods: {
    sendMemoryGA() {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "button",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][我想寫信]"
      });
    },
  },
};
</script>

<style lang="scss">
  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
    outline: none !important;
  }

  .memory-gallery-container  {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #000000;
    overflow: hidden;
    padding: 6vh 0;
    @media only screen and (min-width: 769px) and (max-width: 1024px) {
      padding: 12vh 0;      
    }
    @media only screen and (min-width: 1025px) {
      padding: 18vh 0;
    }
    .memory-gallery-title-wrapper {
      opacity: 0;
      position: relative;
      width: 78%;
      padding: 0 30px;
      margin-top: 18vh;
      @media only screen and (min-width: 769px) and (max-width: 1024px) {
        width: 100%;
        padding: 0 30%;
        margin-top: 0;
      }
      @media only screen and (min-width: 1025px) {
        width: 100%;
        padding: 0 35%;
        margin-top: 0;
      }
    }
    .memory-gallery-title-fade-in {
      animation: fadeInAnimation 2s 2s ease-in-out forwards;
    }
    .memory-gallery-sub-title {
      margin: 10px 0;
      text-align: center;
      color: #57b09f;
      opacity: 0;
    }
    .memory-gallery-sub-title-fade-in {
      animation: fadeInAnimation 1s 3s ease-in-out forwards;
    }
    .memory-button {
      position: relative;
      height: 65px;
      width: 220px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #57b09f;
      border: solid 1px #57b09f;
      opacity: 0;
      cursor: pointer;
      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: inherit;
      }
    }
    .memory-button-fade-in {
      animation: fadeInAnimation 1s 3.5s ease-in-out forwards;
    }

    @keyframes fadeInAnimation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    .memory-gallery-wrapper {
      position: relative;
      width: 100%;
      margin-top: 17vh;
      transform: translateY(100vh);
      @media only screen and (min-width: 1025px) {
        margin-top: 20vh;
      }
    }
    .memory-gallery-fly-in {
      animation: flyInAnimation 1s 4s ease-in-out forwards;
      @keyframes flyInAnimation {
        0% {
          transform: translateY(100vh);
        }
        100% {
          transform: translateY(0);
        }
      }
    }
    .memory-card-wrapper {
      position: relative;
      width: 100px;
      height: 550px;
      padding: 0 10px;
      @media only screen and (min-width: 320px) and (max-width: 374px) {
        height: 420px;
      }
      @media only screen and (min-width: 374px) and (max-width: 414px) {
        height: 450px;
      }
      a {
        text-decoration: none;
        color: inherit;
      }
      .memory-card {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        padding: 30px 20px;
        background-color: #ffffff;
        border: solid 1px #a0d7d3;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        transition: .333s ease-in-out;
        margin: 0;
      }
      .profile-wrapper {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .profile-picture {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .profile-name-wrapper {
          text-align: left;
          overflow: hidden;
          .profile-name {
            line-height: 1.5;
            white-space: nowrap;
          }
          .profile-job {
            font-size: 12px;
            line-height: 1.5;
            color: #6f6f6f;
            white-space: nowrap;
          }
        }
      }
      .text-container {
        position: relative;
        width: 100%;
        height: 75%;
        overflow: hidden;
        .text-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          line-height: 1.6;
          text-align: justify;
          white-space: pre-line;
          color: #000000;
        }
        .text-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: linear-gradient(#ffffff00, #ffffffff);
        }
      }
      .full-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 10%;
        color: #57b09f;
        cursor: pointer;
      }
    }
  }

  .memory-gallery-bg-light {
    animation: bgLightAnimation 2s 0.5s ease-in-out forwards;
    @keyframes bgLightAnimation {
      0% {
        background-color: #000000;
      }
      100% {
        background-color: #f1f1f1;
      }
    }
  }
</style>
